<template>
    <a v-bind:href="recipe.recipe_url" class="card-link">
        <div class="card recipe-card">
            <div class="card-image">
                <img class="responsive-img" v-bind:src="recipe.recipe_featured_image_url">
            </div>
            <div class="card-content">
                <h5>{{ recipe.name }}</h5>
                <!--<div class="row">
                    <div class="col s4 recipe-detail">
                        <i class="fa fa-clock-o" aria-hidden="true"></i> {{ recipe.prep_time }} MIN
                    </div>
                    <div class="col s4 recipe-detail">
                        <i class="fa fa-fire" aria-hidden="true"></i> {{ recipe.cook_time }} MIN
                    </div>
                    <div class="col s4 recipe-detail">
                        <i class="fa fa-user-o" aria-hidden="true"></i> {{ recipe.serve }}
                    </div>
                </div>-->
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: "RecipeCardComponent",
        props: ['recipe']
    }
</script>

<style scoped lang="scss">
    .recipe-card {
        .card-content {
            padding: 15px;
            height: 80px;
            h5 {
                margin-top: 0;
            }


            .recipe-detail {
                font-size: 12px;
                padding: 0 5px;
                text-align: center;
            }
        }
    }
</style>